import React from 'react';
import styled from 'styled-components';
import { onLightTheme } from 'students/views/shared/styled';

const HOME_ICON_GRADIENT = 'navigationHomeGradient';

const HomeIconSvg: React.FC = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <SPath
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6045 2.01046C11.3761 1.24537 12.6179 1.24018 13.393 2.00174C15.3249 3.90004 17.2334 5.82321 19.1415 7.74609C20.194 8.80666 21.2464 9.86714 22.3025 10.9233C22.8246 11.4453 22.8246 12.2917 22.3025 12.8138C21.7805 13.3358 20.9341 13.3358 20.4121 12.8138L20.0206 12.4222V20.5625C20.0206 21.6671 19.1251 22.5625 18.0206 22.5625H5.97964C4.87507 22.5625 3.97964 21.6671 3.97964 20.5625V12.4222L3.58812 12.8138C3.06609 13.3358 2.21971 13.3358 1.69768 12.8138C1.17564 12.2917 1.17564 11.4453 1.69768 10.9233C2.75571 9.86528 3.81184 8.80521 4.86798 7.74513C6.7763 5.82969 8.68469 3.91418 10.6045 2.01046ZM8.02624 13.4396C8.02624 11.2942 9.81801 9.5288 12.0233 9.5288C14.2285 9.5288 15.9743 11.2942 15.9743 13.5737C15.9743 15.6296 14.5501 17.3727 12.0233 19.5851V17.1045H11.8625C9.49641 17.1045 8.02624 15.6519 8.02624 13.4396Z"
      />
      <defs>
        <linearGradient
          id={HOME_ICON_GRADIENT}
          x1="18.6553"
          y1="26.4077"
          x2="8.08997"
          y2="1.44274"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0075E2" />
          <stop offset="1" stopColor="#3BDAFF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default HomeIconSvg;

const SPath = styled.path`
  fill: #a5aac5;

  ${onLightTheme`
    fill: rgb(var(--ln-content) / 0.6);
  `}

  .active & {
    fill: url(#${HOME_ICON_GRADIENT});
  }
`;
